export default function paginateArray(arr, page, pageSize) {
  return arr.slice((page - 1) * pageSize, page * pageSize);
}
